import React from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { setSearchTerm } from '@actions/search';
import Section from '@components/Section';
import styles from './Tips.module.scss';
import { ArrowRightIcon, CircledIIcon } from '@components/Icons';
import analytics from '@support/analytics';
import useSearchTips from '@support/hooks/use-search-tips';
import { openModal } from '@actions/ui';

export const SearchTerm = ({ className, term }: { className?: string; term: string }) => {
  const dispatch = useDispatch();

  const handleSearch = (term) => {
    analytics.track('Query Example Tapped');
    dispatch(setSearchTerm(term.toLowerCase(), true));
  };

  return (
    <span
      className={cn(styles.example, 'text-small', className)}
      onClick={() => handleSearch(term)}
    >
      {term}
    </span>
  );
};

const TipsIcon = (props) => (
  <CircledIIcon {...props} color="textSecondary" width={13} height={13} />
);

export const SearchTips = ({ className }: { className?: string }) => {
  const dispatch = useDispatch();
  const searchTips = useSearchTips();

  const applySearchTerm = (term) => {
    analytics.track('Query Example Tapped');
    dispatch(setSearchTerm(term.toLowerCase(), true));
  };

  return (
    <Section className={cn(styles.tipsContainer, className)}>
      <Section.Title className={styles.title} listItem IconComponent={TipsIcon}>
        Search Tips
      </Section.Title>
      <div className={styles.tipsList}>
        {searchTips.selection.map((tip, idx) => (
          <button key={idx} className={styles.tipBtn} onClick={() => applySearchTerm(tip.term)}>
            <div className={styles.tipTerm}>{tip.term}</div>
            <span className={styles.tipDescription}>{tip.description}</span>
          </button>
        ))}
      </div>
      <button className={styles.exploreBtn} onClick={() => dispatch(openModal('searchEducation'))}>
        Explore all search terms
        <ArrowRightIcon color="textPrimary" />
      </button>
    </Section>
  );
};
